angular.module('forms').controller('FormsCtrl',
    [
        '$scope', 
        '$q', 
        '$uibModal', 
        'TransitionManager', 
        'LocalStorageRepository', 
        'NotificationService', 
        'FormsRepository',
        'PatientPortalStorageRepository',
        'toaster', 
        'aprgettext',
        'BrowserService',
        function (
            $scope, 
            $q, 
            $modal, 
            TransitionManager, 
            LocalStorageRepository, 
            NotificationService, 
            FormsRepository, 
            PatientPortalStorageRepository, 
            toaster, 
            gettext,
            BrowserService
        ) {

            'use strict';

            $scope.loading = false;
            $scope.isModalDisplayed = false;

            $scope.practiceFormsList = null;
            $scope.practiceForm = null;
            $scope.activeList = [];
            $scope.completeList = [];
            $scope.masterList = [];
            $scope.selectedFilterForm = 'Active';
            $scope.filterForm = [ { Name: 'Active', Id: 0 }, {Name: 'Complete', Id: 1 }];

            var selectedPracticeForm = null;
            var activePatient = PatientPortalStorageRepository.getActivePatient();

            $scope.AttachmentList=
            {
                attachmentDto : $scope.attachmentDto
            };

            function filterPracticeForm(filter)
            {
                if(filter.Id === 0)
                {
                    $scope.practiceFormsList = $scope.activeList;
                    $scope.selectedFilterForm = filter.Name;
                }
                if(filter.Id === 1)
                {
                    $scope.practiceFormsList = $scope.completeList;
                    $scope.selectedFilterForm = filter.Name;
                }
            }

            function openPatientQuestionnaire(form) {
                TransitionManager.transition({appRoute: 'patientQuestionnaire', opts: {relSurveyPatientId: form.RelSurveyPatientId, patientId: form.PatientId, questionnaireId: form.QuestionnaireId}});
            }

            function viewPracticeFormAttachment(practiceForm) {
                $scope.isModalDisplayed = true;
                selectedPracticeForm = practiceForm;

                var modalConfig = {
                    Title: practiceForm.PracticeFormName,
                    PatientId: practiceForm.PersonId,
                    DocumentId: practiceForm.AttachmentId,
                    DocumentLoad: getPracticeFormAttachmentImage,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.isModalDisplayed = false;
                    selectedPracticeForm = null;
                });
            }

            function getPracticeFormAttachmentImage(documentId, requestSettings) {
                return FormsRepository.getPracticeFormImage(selectedPracticeForm.PersonId, documentId, selectedPracticeForm.RelPracticeFormPatientId, requestSettings)
                    .then(function (data) {
                        return data;
                });
            }

            function updatePracticeFormDownloadDate(practiceForm) {
                var updateDto = {
                    RelPracticeFormPatientId : practiceForm.RelPracticeFormPatientId
                };

                return FormsRepository.updatePracticeFormDownloadDate(practiceForm.PersonId, practiceForm.AttachmentId, updateDto)
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred while uploading the practice form'));
                    });
            }

            function downloadPracticeFormAttachment(practiceForm) {
                practiceForm.Downloading = true;
                practiceForm.Downloaded = true;
                practiceForm.Uploaded = false;
                updatePracticeFormDownloadDate(practiceForm);
                return FormsRepository.getPracticeFormAttachment(practiceForm.PersonId, practiceForm.AttachmentId, practiceForm.RelPracticeFormPatientId)
                    .then(function (data) {
                        return {Data: data.Data, Extension: data.Extension, FileName: practiceForm.PracticeFormName + '_' + activePatient.firstName + activePatient.lastName};
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred while downloading the practice form'));
                    })
                    .finally(function () {
                        practiceForm.Downloading = false;
                    });
            }

            function getAssignedQuestionnaires() {
                return FormsRepository
                    .getAssignedQuestionnaires(PatientPortalStorageRepository.getActivePatient().id)
                    .then(function (data) {
                        $scope.incompleteForms = _(data)
                            .filter({'IsComplete' : false})
                            .sortBy('PercentComplete')
                            .value();

                        $scope.completedForms = _(data)
                            .filter({'IsComplete' : true})
                            .sortBy('PercentComplete')
                            .value();
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    });
            }

            function getAssignedPracticeForms() {
                var searchCriteria = {
                    IncludeOnlyUnviewedForms : false
                };

                return FormsRepository
                    .getAssignedPracticeForms(PatientPortalStorageRepository.getActivePatient().id, searchCriteria)
                    .then(function (data) {
                        $scope.masterList = _.map(data, function (entry) {
                            return _.assignIn(entry, { Downloading : false, Downloaded: false, Uploading: false, Uploaded: false, isPending : false, isComplete: false});
                        });
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    });

            }

            function createLists()
            {
                if($scope.masterList.length)
                {
                    $scope.completeList =  _($scope.masterList)
                        .filter({'Approved' : true})
                        .sortBy('EffectDate')
                        .value();

                    $scope.activeList = _($scope.masterList)
                        .filter({'Approved' : false})
                        .sortBy('EffectDate')
                        .value();


                    if($scope.activeList)
                    {
                         _.forEach($scope.activeList,function (form) {
                                if(form.LastUploadedByPortalDate !== null && !form.Rejected)
                                {
                                    form.Downloaded = true;
                                    form.isPending = true;
                                    form.Uploaded = true;
                                }
                        });
                    }

                    if(typeof $scope.completeList !== 'undefined')
                    {
                             _.forEach($scope.completeList,function (form) {
                                 form.isComplete = true;
                        });
                    }

                $scope.practiceFormsList = $scope.activeList;
                }
            }
                function assignUploadForm(practiceForm) {
                    $scope.uploadForm = practiceForm;
                }

            $scope.$on('createMessage', function () {
            $scope.uploadForm.Uploading = true;
            // $scope.sending = true;

                var model = {
                    PatientId: activePatient.id,
                    UrgencyId: 'C2A64D38-3BE1-4F8A-8947-EF9E9AD861A4',
                    SubTypeId: 'E6B12F40-A396-41A8-B1FD-F4A2567141C0',
                    MessageTypeId: 'D8799AE1-D76C-4DEF-B7CD-1D89955A7446',
                    Header: $scope.uploadForm.AttachmentTypeName + ' uploaded form from ' + activePatient.fullName + ' needs approval',
                    Message: null,
                    Status: 'Incomplete',
                    Notes: '',
                    AttachmentDto :   $scope.AttachmentList.attachmentDto,
                    PracticeFormId: $scope.uploadForm.PracticeFormId,
                    RelPracticeFormPatientId : $scope.uploadForm.RelPracticeFormPatientId,
                    AttachmentGroupId : $scope.uploadForm.AttachmentGroupId,
                    AttachmentTypeId : $scope.uploadForm.AttachmentTypeId
                };

                FormsRepository
                .createApprovalMessage(activePatient.id, model)
                .then(function () {
                    $scope.uploadForm.isPending = true;
                    toaster.pop('success', '', gettext('Upload sent successfully.'));
                    var uploadDto = { RelPracticeFormPatientId : $scope.uploadForm.RelPracticeFormPatientId};
                    FormsRepository.updatePracticeFormUploadDate(activePatient.id, $scope.uploadForm.AttachmentId, uploadDto);
                    NotificationService.updateNotifications();
                 })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error has occurred and the Form was not uploaded.'));
                    })
                    .finally(function () {
                    //    $scope.sending = false;
                       $scope.uploadForm.Uploading = false;
                    });
            });

            $scope.load = function(tile) {
                $scope.tile = tile;

                loadPage();
            };


            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();

                var assignedQuestionnairesPromise = getAssignedQuestionnaires();
                var assignedPracticeFormsPromise = getAssignedPracticeForms();

                $q.all([assignedQuestionnairesPromise, assignedPracticeFormsPromise]).then(function() {
                    createLists();
                }).finally(function () {
                    $scope.loading = false;
                });
            }
            loadPage();


            $scope.openPatientQuestionnaire = openPatientQuestionnaire;
            $scope.viewPracticeFormAttachment = viewPracticeFormAttachment;
            $scope.getPracticeFormAttachmentImage = getPracticeFormAttachmentImage;
            $scope.downloadPracticeFormAttachment = downloadPracticeFormAttachment;
            $scope.updatePracticeFormDownloadDate = updatePracticeFormDownloadDate;
            $scope.assignUploadForm = assignUploadForm;
            $scope.filterPracticeForm = filterPracticeForm;
        }
    ]
);